import { Injectable } from '@angular/core';
import { ApplicationStateService } from '../../../../../shared/services/application-state.service';

@Injectable({
  providedIn: 'root'
})
export class PredefinedValuesStateService {

  get isDirtyBean() {
    return this.applicationStateService.dirtyFieldsBean
  }

  set isDirtyBean(data) {
    this.applicationStateService.dirtyFieldsBean = data;
  }


  constructor(private applicationStateService: ApplicationStateService) { }
}
